module.exports = __webpack_public_path__ + "assets/img/2d4a9a765a20138ac4cdd3589dc27333.png";